import { useCalculationInput } from "@msuite/ui/hooks";
import { DataTable } from "@msuite/ui/table";
import { guardNumber } from "@msuite/utils/numbers";
import type { OrderFormSchema } from "@msuite/utils/schemas";
import type { ArticleListItem } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";
import { useOrderFormContext } from "../context";

/** Props Interface */
interface OrderFormArticlesQuantityInputProps {
	item: ArticleListItem;
}

export function OrderFormArticlesQuantityInput({ item }: OrderFormArticlesQuantityInputProps) {
	/** Context */
	const { getItemIndex } = useOrderFormContext();
	const itemIndex = getItemIndex(item.id);

	/** Hooks */
	const methods = useFormContext<OrderFormSchema>();
	const name = `articles.${itemIndex}.quantity` as const;
	// An article is ordered by the piece, and a calculation that lands between two pieces has to
	// cover the need rather than fall short of it — "10 / 3" is four scaffold boards, not three.
	// Nothing is ordered in negative pieces, so the floor is zero.
	const calculationInput = useCalculationInput({
		decimals: 0,
		rounding: "ceil",
		min: 0,
		// The field's text reaches form state through a 250 ms debounce, so a blur followed
		// straight by a click on Submit would hand the schema the text as typed. Writing the
		// committed number here is what makes the value the field shows the value that is
		// validated and sent.
		onValue: (value) => methods.setValue(name, guardNumber(value)),
	});

	/** Render */
	return (
		<DataTable.Input
			control={methods.control}
			name={name}
			placeholder="0"
			{...calculationInput.registerCalculationInput()}
		/>
	);
}
